export class GapPoItemVariant {

    size: string;
    upc: string;
    quantity: string;
    unitPrice: string;
    style: string;
    styleDescription: string;
    color:string;
    perPackType:string;

   
}